import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { FixedScrollDirective, SharedComponentsModule } from 'core/shared-components';
import { DsgTranslatePipe } from '../../pipes/translate.pipe';
import { CellComponent } from './cell/cell.component';
import { CustomizeRowDirective } from './customize-row.directive';
import { DataGridActionsComponent } from './data-grid-actions/data-grid-actions.component';
import { DataGridToolbarComponent } from './data-grid-toolbar/data-grid-toolbar.component';
import { DataGridComponent } from './data-grid.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { SearchComponent } from './search/search.component';

@NgModule({
  declarations: [
    DataGridComponent,
    PaginatorComponent,
    CellComponent,
    DataGridActionsComponent,
    DataGridToolbarComponent,
    SearchComponent,
    CustomizeRowDirective
  ],
  exports: [
    DataGridComponent,
    DataGridActionsComponent,
    DataGridToolbarComponent
  ],
  // providers: [CdkColumnDef],
  imports: [
    CommonModule,
    MatTableModule,
    MatSelectModule,
    MatIconModule,
    DsgTranslatePipe,
    MatPaginatorModule,
    SharedComponentsModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    FixedScrollDirective
  ]
})
export class DataGridModule { }
